import React from 'react'
import classnames from 'classnames'
import s from './ToggleFullScreenGeButton.less'
import { withEverySelectorTruthy } from '../../utils/react-redux'
import { toggleFullscreen } from '../../../store/map/mapSlice'
import useEventCallback from '../../utils/useEventCallback'
import { withOnlyGE } from '../../Device'
import ReduireDesktop from './reduire-desktop.svg'
import SVGIcon from '../../svg/SVGIcon'
import { selectIsMapFullScreen, selectShouldDisplayToggleFullScreenGeButton } from '../../../store/map/map.selectors'
import { useDispatch, useSelector } from 'react-redux'
import { ACTION } from '../../analytics/ClickTagsService'
import TagActionButton from '../../genericComponents/TagActionButton'
import { TAG_CLICK_TOGGLE_FULLSCREEN } from '../../analytics/analytics.tagids.constants'

const ToggleFullScreenGeButton = () => {
  const dispatch = useDispatch()
  const isMapFullScreen = useSelector(selectIsMapFullScreen)

  const onClick = useEventCallback(() => {
    dispatch(toggleFullscreen())
  }, [toggleFullscreen])

  return (
    <TagActionButton
      className={s.container}
      type={TAG_CLICK_TOGGLE_FULLSCREEN}
      tagInfo={{ [ACTION]: isMapFullScreen ? 'Ouvrir' : 'Fermer' }}
      onClick={onClick}
    >
      <SVGIcon url={ReduireDesktop} className={classnames(s.icon, isMapFullScreen ? s.invert : undefined)} />
    </TagActionButton>
  )
}

export default withOnlyGE(
  withEverySelectorTruthy(selectShouldDisplayToggleFullScreenGeButton)(ToggleFullScreenGeButton)
)
